var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { class: _vm.question.getQuestionRootCss() }, [
    _c(
      "tbody",
      [
        _vm._l(_vm.question.getRows(), function (row, rowIndex) {
          return [
            row.isVisible
              ? _c(
                  "tr",
                  {
                    key: _vm.question.inputId + "rowkey" + rowIndex,
                    class: _vm.question.cssClasses.row,
                  },
                  _vm._l(row.cells, function (cell) {
                    return _c(
                      "td",
                      {
                        key: "item" + cell.item.editor.id,
                        class: cell.className,
                      },
                      [
                        _c("survey-multipletext-item", {
                          attrs: { question: _vm.question, cell: cell },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }